import React, { FC } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { Text, Image, sounds } from '@whitesharx/starfall-frontend-ui-kit';
import { TAP_EVENTS, GAME_PLATFORM_ANALYTIC, useServices } from '@whitesharx/starfall-frontend-core';

import {
  bannerStyles,
  textStyles,
  linksContainerStyles,
  titleImageStyles,
  appleImageStyles,
  googleImageStyles,
  googleLinkStyles,
} from './styles.css';

const playSound = () => sounds.play('click');

const APP_STORE_URL = 'https://apps.apple.com/app/chess-royale-play-board-game/id1434658250';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.xten.starfall';

const ChessRoyaleBanner: FC = () => {
  const { Analytics } = useServices();

  const onGooglePlay = () => {
    Analytics.sendEvent(TAP_EVENTS.mobileAppBanner, { type: 'GooglePlay', gamePlatform: GAME_PLATFORM_ANALYTIC.pc });
  };
  const onAppStore = () => {
    Analytics.sendEvent(TAP_EVENTS.mobileAppBanner, { type: 'AppStore', gamePlatform: GAME_PLATFORM_ANALYTIC.pc });
  };

  return (
    <>
      <div className={bannerStyles}>
        <Image className={titleImageStyles} src="/assets/images/chess-banner-title.webp" />
        <Text fontWeight="medium" textTransform="uppercase" color="aubergine900" className={textStyles}>
          {t('install-and-get-bonuse')}
        </Text>
        <Image alt="chess" src="assets/images/chess.avif" width="215px" height="137px" />
      </div>
      <div className={linksContainerStyles} onClick={playSound}>
        <a target="_blank" href={GOOGLE_PLAY_URL} className={googleLinkStyles}>
          <div onClick={onGooglePlay}>
            <Image className={googleImageStyles} src="/assets/images/google-marketplace.webp" />
          </div>
        </a>
        <a target="_blank" href={APP_STORE_URL}>
          <div onClick={onAppStore}>
            <Image className={appleImageStyles} src="/assets/images/apple-marketplace.webp" />
          </div>
        </a>
      </div>
    </>
  );
};

export default ChessRoyaleBanner;
